<app-header></app-header>

<div class="page-title-area newsBg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routeLink="/">Acasa</a></li>
                <li>Anunturi</li>
            </ul>
            <h2>Anunturi</h2>
        </div>
    </div>
</div>
<section class="bg my-5">
    <div class="container">
        <div class="row" *ngFor="let notice of news">

                <a class="col-lg-8 newsItem offset-lg-2" routerLink="/anunturi/anunt/{{notice.id}}">
                    <div class="img">

                        <div *ngIf="notice.photo"><img [src]="setFilePath(notice)" alt="test"></div>
                        <div *ngIf="!notice.photo"><img src="../../../assets/img/placeImg.jpg" alt=""></div>

<!--                        <div *ngIf="notice.photo; then thenBlock else elseBlock"></div>
                        <ng-template #thenBlock><img src='{{filepath}}' alt="test"></ng-template>
                        <ng-template #elseBlock><img src="../../../assets/img/placeImg.jpg" alt=""></ng-template>-->

<!--                        <img src="../../../assets/img/placeImg.jpg" alt="">-->
                    </div>
                    <div class="content">
                        <h3>{{notice.title}}</h3>
                        <p>{{notice.abstract}}</p>
                    </div>
                    <div class="date">
                        {{notice.date | date:'dd/MM/yyyy'}}
                    </div>
                </a>

        </div>
    </div>
</section>
